import * as fromDatatype from "../datatype-library";

export interface bl_alg_cc_task_hdr_RowInterface {
  //public static final String tableAlias = "task_hdr";
  guid: fromDatatype.GuidDataFieldInterface;
  queue_guid: fromDatatype.GuidDataFieldInterface;
  agent_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeClass;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_guid: fromDatatype.VarcharDatatypeInterface;
  //private Map<String, Object> target_property_json = new HashMap<String, Object>();
  target_property_json: fromDatatype.JsonDatatypeInterface;
  task_status: fromDatatype.VarcharDatatypeInterface;
  task_category: fromDatatype.VarcharDatatypeInterface;
  //private Map<String, Object> property_json = new HashMap<String, Object>();
  property_json: fromDatatype.JsonDatatypeInterface;
  //private Map<String, Object> acl_config = new HashMap<String, Object>();
  acl_config: fromDatatype.JsonDatatypeInterface;
  //private Map<String, Object> acl_policy = new HashMap<String, Object>();
  acl_policy: fromDatatype.JsonDatatypeInterface;
  assign_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  //private StatusColumn status;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  assignee_table: fromDatatype.VarcharDatatypeInterface;
  assignee_guid: fromDatatype.GuidDataFieldInterface;
  project_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_alg_cc_task_hdr_RowClass
  implements bl_alg_cc_task_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  queue_guid: fromDatatype.GuidDataFieldInterface;
  agent_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeClass;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_guid: fromDatatype.VarcharDatatypeInterface;
  //private Map<String, Object> target_property_json = new HashMap<String, Object>();
  target_property_json: fromDatatype.JsonDatatypeInterface;
  task_status: fromDatatype.VarcharDatatypeInterface;
  task_category: fromDatatype.VarcharDatatypeInterface;
  //private Map<String, Object> property_json = new HashMap<String, Object>();
  property_json: fromDatatype.JsonDatatypeInterface;
  //private Map<String, Object> acl_config = new HashMap<String, Object>();
  acl_config: fromDatatype.JsonDatatypeInterface;
  //private Map<String, Object> acl_policy = new HashMap<String, Object>();
  acl_policy: fromDatatype.JsonDatatypeInterface;
  assign_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  //private StatusColumn status;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  assignee_table: fromDatatype.VarcharDatatypeInterface;
  assignee_guid: fromDatatype.GuidDataFieldInterface;
  project_guid: fromDatatype.GuidDataFieldInterface;
}